// extracted by mini-css-extract-plugin
module.exports = {"mobile-overflow":"_1XM7iBnK","mobileOverflow":"_1XM7iBnK"};